import React, { useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { FaInfoCircle } from "react-icons/fa";

const ClassDepLocInfo = () => {
  const [open, setOpen] = useState(false);

  const openModal = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        aria-label="Class Department Location info"
        onClick={openModal}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") openModal(event);
        }}
        style={{ display: "inline-block", marginLeft: 4, verticalAlign: "middle", cursor: "pointer" }}
      >
        <FaInfoCircle />
      </span>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: 640,
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 24px 80px rgba(0,0,0,0.25)",
              overflow: "hidden",
              textAlign: "left",
            }}
          >
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
                Class / Department / Location
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                style={{ border: "none", background: "transparent", fontSize: 20, cursor: "pointer", color: "#64748b" }}
              >
                &times;
              </button>
            </div>

            <div style={{ padding: 20, color: "#1e293b", lineHeight: 1.6, fontSize: 14 }}>
              <p style={{ margin: "0 0 12px" }}>
                This field is used for mapping accounting dimensions such as Class, Department,
                and Location, primarily for QuickBooks integrations.
              </p>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Format:</div>
              <div style={{ marginBottom: 12 }}>Class / Department / Location</div>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Examples:</div>
              <div style={{ marginBottom: 12 }}>
                <div>C1/DP1/LOC1</div>
                <div>Class = C1</div>
                <div>Department = DP1</div>
                <div>Location = LOC1</div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <div>{"//LOC2"}</div>
                <div>Class = empty</div>
                <div>Department = empty</div>
                <div>Location = LOC2</div>
              </div>
              <p style={{ margin: 0 }}>
                Any section can be left empty by keeping the / separator in place.
              </p>
            </div>

            <div style={{ padding: "16px 20px", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end" }}>
              <Button size="small" fill="true" onClick={() => setOpen(false)}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClassDepLocInfo;
